export default __webpack_public_path__ + "static/media/beer-header-logo.2085286b.png";